module.exports = __webpack_public_path__ + "img/papers.cc30dde7.jpg";